/**
 * COMPONENT: GameMenu
 * Menu e stati del gioco (menu, pausa, game over, win)
 */

import React from "react";
import { DifficultyPreset, GameState } from "../types/GameTypes";

interface GameMenuProps {
    gameState: GameState;
    score: number;
    difficultyPreset: DifficultyPreset;
    onStart: () => void;
    onTogglePause: () => void;
}

export const GameMenu: React.FC<GameMenuProps> = ({
    gameState,
    score,
    difficultyPreset,
    onStart,
    onTogglePause,
}) => {
    if (gameState === "playing") return null;

    const isPause = gameState === "paused";
    const canRestart =
        gameState === "menu" || gameState === "gameOver" || gameState === "win";

    return (
        <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/70">
            <div className="w-[92%] max-w-[460px] rounded-xl border border-white/20 bg-black/60 p-6 text-center font-mono shadow-2xl backdrop-blur-sm">
                {gameState === "menu" ? (
                    <>
                        <div className="mb-6 text-4xl font-bold text-yellow-400">
                            PAC-MAN
                        </div>
                        <div className="mb-2 text-sm text-white/90">
                            Frecce o WASD per muoverti
                        </div>
                        <div className="mb-2 text-xs text-emerald-200/90">
                            Difficolta: {difficultyPreset.toUpperCase()} (`1/2/3`)
                        </div>
                        <div className="mb-6 text-xs text-white/70">
                            `P` o `ESC` pausa • `M` radar • `SPACE` start/restart
                        </div>
                    </>
                ) : null}

                {isPause ? (
                    <>
                        <div className="mb-3 text-3xl font-bold text-white">
                            IN PAUSA
                        </div>
                        <div className="mb-6 text-sm text-white/75">
                            Riprendi quando vuoi, il radar resta aggiornato.
                        </div>
                    </>
                ) : null}

                {gameState === "gameOver" ? (
                    <>
                        <div className="mb-3 text-3xl font-bold text-red-500">
                            GAME OVER
                        </div>
                        <div className="mb-6 text-sm text-white/85">
                            Punteggio finale: {score}
                        </div>
                    </>
                ) : null}

                {gameState === "win" ? (
                    <>
                        <div className="mb-3 text-3xl font-bold text-green-500">
                            HAI VINTO!
                        </div>
                        <div className="mb-6 text-sm text-white/85">
                            Punteggio finale: {score}
                        </div>
                    </>
                ) : null}

                <div className="flex flex-wrap items-center justify-center gap-2">
                    {isPause ? (
                        <button
                            type="button"
                            onClick={onTogglePause}
                            className="rounded-md border border-cyan-300/50 bg-cyan-500/20 px-4 py-2 text-sm font-semibold text-cyan-100 transition hover:bg-cyan-500/30"
                        >
                            Riprendi
                        </button>
                    ) : null}
                    {canRestart ? (
                        <button
                            type="button"
                            onClick={onStart}
                            className="rounded-md border border-yellow-300/50 bg-yellow-500/20 px-4 py-2 text-sm font-semibold text-yellow-100 transition hover:bg-yellow-500/30"
                        >
                            {gameState === "menu" ? "Inizia Partita" : "Gioca Ancora"}
                        </button>
                    ) : null}
                </div>
            </div>
        </div>
    );
};
